import api from "./server";
export default {



  /**
   * 登录
   * @param {*} p 
   * @returns 
   */
  async Login(p) {
    return await api.post("user/login", p);
  },


  /**
   * 上传
   * @param {*} p
   * @param {*} s
   * @returns 
   */
  async upload(p, r) {
    return await api.upload(p, r);
  },



  /**
   * 获取表單提交的數據
   * @param {*} p
   * @param {*} s
   * @returns 
   */
  async Queryinfo(p) {
    return await api.get("other/queryinfo", p);
  },


  /**
   * 获取用户列表
   * @param {*} p 
   * @returns 
   */
  async QueryUserList(p) {
    return await api.get("user/queryuserlist", p);
  },

  /**
    * 修改用户余额
    * @param {*} p 
    * @returns 
    */
  async UpdaUserMoney(p) {
    return await api.post("user/updausermoney", p);
  },

  /**
* 获取基础信息
* @param {*} p 
* @returns 
*/
  async QueryConfig(p) {
    return await api.get("other/queryconfig", p);
  },

  /**
  * 获取用户推广列表
  * @param {*} p 
  * @returns 
  */
  async QueryPromotion(p) {
    return await api.get("user/querypromotion", p);
  },

  /**
   * 获取商家列表
   * @param {*} p 
   * @returns 
   */
  async QueryMerchant(p) {
    return await api.get("user/querymerchant", p);
  },

  /**
 * 审核商家
 * @param {*} p 
 * @returns 
 */
  async UserExamine(p) {
    return await api.post("user/examine", p);
  },


  /**
   * 获取商品列表
   * @param {*} p 
   * @returns 
   */
  async GoodsQueryList(p) {
    return await api.get("goods/querylist", p);
  },

  /**
   * 获取商品规格
   * @param {*} p 
   * @returns 
   */
  async GoodsQueryAttr(p) {
    return await api.get("goods/queryattr", p);
  },

  /**
  * 删除商品
  * @param {*} p 
  * @returns 
  */
  async GoodsDele(p) {
    return await api.post("goods/dele", p);
  },

  /**
  * 上下架商品
  * @param {*} p 
  * @returns 
  */
  async GoodsUpdaframe(p) {
    return await api.post("goods/updaframe", p);
  },

  /**
   * 获取分类列表
   * @param {*} p 
   * @returns 
   */
  async QueryTypeList(p) {
    return await api.get("other/querytypelist", p);
  },

  /**
  * 获取订单列表
  * @param {*} p 
  * @returns 
  */
  async QueryOrdersList(p) {
    return await api.get("orders/querylist", p);
  },

  /**
  * 获取明细列表
  * @param {*} p 
  * @returns 
  */
  async BilldetailsQuerylist(p) {
    return await api.get("billdetails/querylist", p);
  },

  /**
  * 获取新闻列表
  * @param {*} p 
  * @returns 
  */
  async NewsQuerynews(p) {
    return await api.get("news/querynews", p);
  },

  /**
  * 添加新闻
  * @param {*} p 
  * @returns 
  */
  async NewsAddnews(p) {
    return await api.post("news/addnews", p);
  },

  /**
* 修改新闻
* @param {*} p 
* @returns 
*/
  async NewsUpdatenews(p) {
    return await api.post("news/updatenews", p);
  },

  /**
   * 删除新闻
   * @param {*} p 
   * @returns 
   */
  async NewsDeletenews(p) {
    return await api.post("news/deletenews", p);
  },


  /**
  * 获取oss
  * @param {*} p 
  * @returns 
  */
  async OtherQueryoss(p) {
    return await api.get("other/queryoss", p);
  },

  /**
  * 上传图片
  * @param {*} p
  * @param {*} s
  * @returns 
  */
  async upload(p, r) {
    return await api.upload(p, r);
  },


  /**
  * 查询分类
  * @param {*} p 
  * @returns 
  */
  async OtherQuerytypelist(p) {
    return await api.get("other/querytypelist", p);
  },

  /**
* 新增分类
* @param {*} p 
* @returns 
*/
  async OtherAddtype(p) {
    return await api.post("other/addtype", p);
  },

  /**
 * 修改分类
 * @param {*} p 
 * @returns 
 */
  async OtherUpdatetype(p) {
    return await api.post("other/updatetype", p);
  },

  /**
  * 删除分类
  * @param {*} p 
  * @returns 
  */
  async OtherDeletetype(p) {
    return await api.post("other/deletetype", p);
  },

  /**
  * 获取协议列表
  * @param {*} p 
  * @returns 
  */
  async OtherQueryprotocol(p) {
    return await api.get("other/queryprotocol", p);
  },

  /**
 * 修改协议
 * @param {*} p 
 * @returns 
 */
  async OtherUpdaprotocol(p) {
    return await api.post("other/updaprotocol", p);
  },

  /**
* 获取程序配置
* @param {*} p 
* @returns 
*/
  async OtherQueryconfig(p) {
    return await api.get("other/queryconfig", p);
  },

  /**
* 保存配置
* @param {*} p 
* @returns 
*/
  async OtherUpdateconfig(p) {
    return await api.post("other/updateconfig", p);
  },


  /**
* 查询銷售列表
* @param {*} p 
* @returns 
*/
  async UserQuerytypelist(p) {
    return await api.get("user/queryrecommend", p);
  },

  /**
* 新增銷售
* @param {*} p 
* @returns 
*/
  async UserAddtype(p) {
    return await api.post("user/addrecommend", p);
  },

  /**
 * 修改銷售
 * @param {*} p 
 * @returns 
 */
  async UserUpdatetype(p) {
    return await api.post("user/updarecommend", p);
  },

  /**
  * 删除銷售
  * @param {*} p 
  * @returns 
  */
  async UserDeletetype(p) {
    return await api.post("user/deleuser", p);
  },



  /**
* 获取通知列表
* @param {*} p 
* @returns 
*/
  async QueryNotice(p) {
    return await api.get("other/querynotice", p);
  },

  /**
* 修改通知内容
* @param {*} p 
* @returns 
*/
  async UpdaNotice(p) {
    return await api.post("other/updanotice", p);
  },
  /**
 * 修改通知内容
 * @param {*} p 
 * @returns 
 */
  async Addnotice(p) {
    return await api.post("other/addnotice", p);
  },
  /**
 * 刪除
 * @param {*} p 
 * @returns 
 */
  async Delenotice(p) {
    return await api.post("other/delenotice", p);
  },


  /**
  * 左側菜單查詢列表 多級數組
  * @param {*} p
  * @param {*} s
  * @returns 
  */
  async Querymenujson(p) {
    return await api.get("user/querymenujson", p);
  },
  /**
 * 左側菜單查詢列表 单级数组
 * @param {*} p
 * @param {*} s
 * @returns 
 */
  async Querymenu(p) {
    return await api.get("user/querymenu", p);
  },
  /**
 * 刪除菜单
 * @param {*} p 
 * @returns 
 */
  async Deletemenu(p) {
    return await api.post("user/deletemenu", p);
  },
  /**
  * 修改菜单
  * @param {*} p 
  * @returns 
  */
  async Updamenu(p) {
    return await api.post("user/updamenu", p);
  },
  /**
 * 添加菜单
 * @param {*} p 
 * @returns 
 */
  async Addmenu(p) {
    return await api.post("user/addmenu", p);
  },
  /**
* 查詢管理員
* @param {*} p
* @param {*} s
* @returns 
*/
  async Queryuser(p) {
    return await api.get("user/queryuser", p);
  },
  /**
 * 添加管理員
 * @param {*} p 
 * @returns 
 */
  async Adduser(p) {
    return await api.post("user/adduser", p);
  },
  /**
* 修改管理員
* @param {*} p 
* @returns 
*/
  async Upduser(p) {
    return await api.post("user/upduser", p);
  },
  /**
* 刪除管理員
* @param {*} p 
* @returns 
*/
  async Deleadminuser(p) {
    return await api.post("user/deleadminuser", p);
  },


  /**
* 查詢接口
* @param {*} p
* @param {*} s
* @returns 
*/
  async Queryinterfa(p) {
    return await api.get("user/queryinterfa", p);
  },
  /**
  * 添加接口
  * @param {*} p 
  * @returns 
  */
  async Addinterfa(p) {
    return await api.post("user/addinterfa", p);
  },
  /**
  * 修改菜單
  * @param {*} p 
  * @returns 
  */
  async Updainterfa(p) {
    return await api.post("user/updainterfa", p);
  },
  /**
  * 刪除管理員
  * @param {*} p 
  * @returns 
  */
  async Deleinterfa(p) {
    return await api.post("user/deleinterfa", p);
  },

  /**
* 獲取菜單權限
* @param {*} p
* @param {*} s
* @returns 
*/
  async Querypermission(p) {
    return await api.get("user/querypermission?", p);
  },
  /**
* 獲取請求接口權限
* @param {*} p
* @param {*} s
* @returns 
*/
  async Queryintession(p) {
    return await api.get("user/queryintession?", p);
  },
  /**
   * 取消菜單 或接口權限
   * @param {*} p 
   * @returns 
   */
  async Delepermission(p) {
    return await api.post("user/delepermission", p);
  },
  /**
   * 添加請求接口權限
   * @param {*} p 
   * @returns 
   */
  async Addintession(p) {
    return await api.post("user/addintession", p);
  },
  /**
   * 添加菜單顯示權限
   * @param {*} p 
   * @returns 
   */
  async Addpermission(p) {
    return await api.post("user/addpermission", p);
  },
  /**
    * 修改登錄密碼
    * @param {*} p 
    * @returns 
    */
  async Uppass(p) {
    return await api.post("user/uppass", p);
  },

  /**
   * 获取优惠卷列表
   * @param {*} p 
   * @returns 
   */
  async CouponQuerycp(p) {
    return await api.get("coupon/querycp", p);
  },

  /**
    * 添加优惠卷
    * @param {*} p 
    * @returns 
    */
  async CouponAddcp(p) {
    return await api.post("coupon/addcp", p);
  },

  /**
    * 修改优惠卷
    * @param {*} p 
    * @returns 
    */
  async CoupoUpdacp(p) {
    return await api.post("coupon/updacp", p);
  },

  /**
   * 删除优惠卷
   * @param {*} p 
   * @returns 
   */
  async CouponDelecp(p) {
    return await api.post("coupon/delecp", p);
  },
  /**
  * 获取輪播圖
  * @param {*} p 
  * @returns 
  */
  async QueryRotating(p) {
    return await api.get("other/queryrotating", p);
  },
  async Addrotating(p) {
    return await api.post("other/addrotating", p);
  },
  async Updaterotating(p) {
    return await api.post("other/updaterotating", p);
  },

  /* 修改商家信息 */
  async Upuserinfo(p) {
    return await api.post("user/upuserinfo", p);
  },


  
    /**
   * 获取渠道
   * @param {*} p 
   * @returns 
   */
    async Querypay(p) {
      return await api.get("user/querypay", p);
    },
     /**
   * 获取商家支付渠道
   * @param {*} p 
   * @returns 
   */
     async Querymepay(p) {
      return await api.get("user/querymepay", p);
    },
    

  /**
   * 添加商家支付渠道
   * @param {*} p 
   * @returns 
   */
  
  async Addpay(p) {
    return await api.post("user/addpay", p);
  },
  /**
   * 修改商家支付渠道
   * @param {*} p 
   * @returns 
   */
  async Updapay(p) {
    return await api.post("user/updapay", p);
  },
    /**
   * 删除商家支付渠道
   * @param {*} p 
   * @returns 
   */
    async Delpay(p) {
      return await api.post("user/delpay", p);
    },
    

    /**
     * 退款
     */
    async Refund(p) {
      return await api.post("orders/refund", p);
    },

     /**
     * 获取物流信息
     */
    async querytrack(p) {
      return await api.get("orders/querytrack", p);
    },

     /**
     * 获取物流信息
     */
    async queryexpress(p) {
      return await api.get("other/queryexpress", p);
    },

      /**
     * 确认发货
     */
    async shipment(p) {
      return await api.post("orders/shipment", p);
    },

    /**
     * 获取联系人列表
     */
    async querycontactlist(p) {
      return await api.get("chat/contactlist", p);
    },


    /**
     * 获取聊天记录
     */
    async querycontenlist(p) {
      return await api.get("chat/contenlist", p);
    },

     /**
     * 标记已读
     */
    async chatread(p) {
      return await api.post("chat/read", p);
    },

     /**
     * 修改物流信息
     */
    async modifylogi(p) {
      return await api.post("orders/modifylogi", p);
    },

    /**
     * 获取退款记录
     */
    async queryRefund(p) {
      return await api.get("orders/queryrefund", p);
    },

      /**
     * 退款处理
     */
    async processRefund(p) {
      return await api.post("orders/processrefund", p);
    },

      /**
     * 申请全额退款
     */
    async fullrefund(p) {
      return await api.post("orders/fullrefund", p);
    },





    
    
    
  

}







